// extracted by mini-css-extract-plugin
module.exports = {"main":"e_Ce","gdrInfo":"e_De","gdrLink":"e_Ee","gdrButton":"e_Fe"};